import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap flex-sm-nowrap" }
const _hoisted_2 = { class: "me-7 mb-4" }
const _hoisted_3 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative img-thumbnail" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "upload-image-button btn btn-icon btn-circle btn-active-color-primary bg-white shadow",
  title: "Upload Image",
  "data-bs-toggle": "modal",
  "data-bs-target": "#winner-image-modal"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" })
], -1)
const _hoisted_5 = { class: "image-slot" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-body h-20px w-20px" }, null, -1)
const _hoisted_7 = { class: "flex-grow-1" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = { class: "d-flex align-items-center mb-2" }
const _hoisted_11 = {
  href: "#",
  class: "text-gray-900 text-hover-primary fs-2 fw-bold me-1"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-verify fs-1 text-primary" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
    /*#__PURE__*/_createElementVNode("span", { class: "path2" })
  ])
], -1)
const _hoisted_13 = { class: "d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2" }
const _hoisted_14 = {
  href: "#",
  class: "d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-profile-circle fs-4 me-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path3" })
], -1)
const _hoisted_16 = {
  href: "#",
  class: "d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-geolocation fs-4 me-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)
const _hoisted_18 = {
  href: "#",
  class: "d-flex align-items-center text-gray-500 text-hover-primary mb-2"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-sms fs-4 me-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_ImageUploadModal = _resolveComponent("ImageUploadModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_el_image, {
            src: _ctx.imageSrc,
            class: "align-middle",
            lazy: "",
            fit: "contain"
          }, {
            error: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon_picture)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["src"]),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.winners[0]?.first_name) + " " + _toDisplayString(_ctx.winners[0]?.last_name), 1),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("a", _hoisted_14, [
                _hoisted_15,
                _createTextVNode(" " + _toDisplayString(_ctx.winners[0] ? _ctx.formatPlace(_ctx.winners[0]?.place) : 'No') + " place ", 1)
              ]),
              _createElementVNode("a", _hoisted_16, [
                _hoisted_17,
                _createTextVNode(" Entry Code: " + _toDisplayString(_ctx.winners[0]?.entry_code), 1)
              ]),
              _createElementVNode("a", _hoisted_18, [
                _hoisted_19,
                _createTextVNode(" Prize: " + _toDisplayString(_ctx.draw?.prize), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ImageUploadModal, {
      "modal-id": `winner-image-modal`,
      image: _ctx.imageSrc,
      onRemoveImage: _ctx.handleRemoveWinnerImage,
      onUploadImage: _ctx.handleUploadWinnerImage
    }, null, 8, ["image", "onRemoveImage", "onUploadImage"])
  ], 64))
}